const keyBase64 = 'Me2K8yRARBeZ+4NOg6QSzHEq76A6yxxYH03KqUpUVQs='

// AES-256-GCM解密
export const aesGcmDecrypt = async (cipherBase64) => {
  try {
    // 1. Base64 解码密钥和密文
    const keyBuffer = base64ToArrayBuffer(keyBase64)
    const fullData = base64ToArrayBuffer(cipherBase64)

    // 2. 导入密钥
    const cryptoKey = await crypto.subtle.importKey(
      'raw',
      keyBuffer,
      { name: 'AES-GCM' },
      false,          // 是否可导出
      ['decrypt']     // 只用于解密
    )

    // 3. 分离 nonce（前12字节）和 密文+tag
    const nonce = fullData.slice(0, 12)
    const cipherWithTag = fullData.slice(12)

    // 4. 解密
    const decrypted = await crypto.subtle.decrypt(
      {
        name: 'AES-GCM',
        iv: nonce,
        tagLength: 128      // GCM tag 长度 128 位 = 16 字节（Go 默认）
      },
      cryptoKey,
      cipherWithTag
    )

    // 5. ArrayBuffer → 字符串
    return new TextDecoder().decode(decrypted)
  } catch (error) {
    console.dir(error)
    console.error('解密失败：', error.message)
    return ''
  }
}

// AES-256-GCM加密
export const aesGcmEncrypt = async (data) => {
  try {
    // 1. 解析密钥（Base64 → ArrayBuffer）
    const keyBuffer = base64ToArrayBuffer(keyBase64)

    // 2. 导入密钥
    const cryptoKey = await crypto.subtle.importKey(
      'raw',
      keyBuffer,
      { name: 'AES-GCM' },
      false,
      ['encrypt']
    )

    // 3. 生成 12 字节随机 nonce（对应后端的 NonceSize）
    const nonce = crypto.getRandomValues(new Uint8Array(12))

    // 4. 准备明文数据
    const plainText = typeof data === 'string' ? data : JSON.stringify(data)
    const encoder = new TextEncoder()
    const plainBuffer = encoder.encode(plainText)

    // 5. 加密
    const cipherBuffer = await crypto.subtle.encrypt(
      {
        name: 'AES-GCM',
        iv: nonce,
        tagLength: 128  // GCM tag 长度 128 位
      },
      cryptoKey,
      plainBuffer
    )

    // 6. 拼接 nonce + ciphertext（对应后端 fullData := append(nonce, cipherWithTag...)）
    const cipherArray = new Uint8Array(cipherBuffer)
    const fullData = new Uint8Array(nonce.length + cipherArray.length)
    fullData.set(nonce, 0)
    fullData.set(cipherArray, nonce.length)

    // 7. 转为 Base64
    return arrayBufferToBase64(fullData.buffer)
  } catch (error) {
    console.dir(error)
    console.error('加密失败：', error.message)
    return ''
  }
}

//  Base64 字符串转 ArrayBuffer
const base64ToArrayBuffer = (base64) => {
  const binaryString = atob(base64)
  const bytes = new Uint8Array(binaryString.length)
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes.buffer
}

// ArrayBuffer 转 Base64 字符串
const arrayBufferToBase64 = (buffer) => {
  const bytes = new Uint8Array(buffer)
  let binaryString = ''
  for (let i = 0; i < bytes.length; i++) {
    binaryString += String.fromCharCode(bytes[i])
  }
  return btoa(binaryString)
}
